module.exports = __webpack_public_path__ + "img/credits.d1d8c86b.svg";